import React, { useState, useEffect, useRef } from "react";
import Header from "components/Headers/Header";
import DataTable from "react-data-table-component";

import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  CardBody,
  FormGroup,
  Input,
  CardFooter,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,

} from "reactstrap";

import moment from "moment-timezone";
import ReactDatetime from "react-datetime";
import { connect, useDispatch } from "react-redux";
import {
  fetchCoachTutorAvailability,
  createWeeklyHoursCoachAvailability,
  fetchWeeklyHoursCoachAvailability,
  updateWeeklyHoursCoachAvailability,
  deleteWeeklyHoursCoachAvailability,
  createWeeklyHoursCoachAvailabilityReset,
  deleteWeeklyHoursCoachAvailabilityReset,
  updateWeeklyHoursCoachAvailabilityReset,
} from "redux/ManageCoachTutorAvailability/ManageCoachTutorAvailabilityActions";
import Swal from "sweetalert2";
import { db } from "../../firebase";
import CoachSchedule from "components/Pages/CoachSchedule";
import {
  getDoc,
  addDoc,
  collection,
  doc,
} from "firebase/firestore";

import { debounce } from "lodash";
import { ToastContainer, toast } from "react-toastify";

moment.tz.setDefault("America/New_York");

const ManageCoachTutorAvailability = (props) => {
    const dispatch = useDispatch();
    
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(true);
    const [repeatDays, setRepeatDays] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [startTime, setStartTime] = useState();
    const [endTime, setEndTime] = useState();
    const [selectedDays, setSelectedDays] = useState([]);
    const [schedules, setSchedules]  = useState([]);

    const [search, setSearch] = useState("");
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState([]);
    
    const [cutoffHours, setCutoffHours] = useState(0);
    
    


    // useEffect(() => {
    //     const unsub = onSnapshot(query(collection(db, "coachAvailableSchedule"), where("userHandle", "==",props.userDetails.handle ), orderBy("createdAt","desc")), (snapshot) =>
    //         setSchedules(snapshot.docs.map((doc) => (
    //           { ...doc.data(), schedid: doc.id 
                
    //           }
    //       )))
    //     );
    //     return unsub
    // },[props]);
    // useEffect(() => {
    // const unsub = onSnapshot(
    //     query(collection(db, "coachAvailableSchedule"), where("userHandle", "==" ,props.userDetails.handle), orderBy("createdAt", "desc")),
    //     (snapshot) => {
    //         setSchedules(
    //         snapshot.docs.map((doc) => ({ ...doc.data(), schedid: doc.id }))
    //         );
    //     },
    //     (error) => {
    //         console.log("Error");
    //     }
    //     );
    //     return unsub;
    // }, [props]);

    useEffect(() => {
       dispatch(fetchCoachTutorAvailability({handle: props.userDetails.handle}));
    }, [props.userDetails]);

  useEffect(() => {
    if (props.fetchCoachTutorAvailability.loading) {
      Swal.fire({
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }

    if (props.fetchCoachTutorAvailability.fetchcoachtutoravailability.length) {
      

      const fetchcoachtutoravailability = props.fetchCoachTutorAvailability.fetchcoachtutoravailability[0]
      fetchcoachtutoravailability.sort((a, b) => moment(a.starttime) - moment(b.starttime));

      setData(
        fetchcoachtutoravailability
      );
        setFilter(
        fetchcoachtutoravailability
      );

      
    }
  }, [props.fetchCoachTutorAvailability]);

    const customStyles = {
        menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
    };

    let twoDaysBefore = moment().tz("America/New_York");
    let valid = function (current) {
      
        return moment(current.format("MMM D, YYYY"),"MMM D, YYYY").isSameOrAfter(moment(twoDaysBefore.format("MMM D, YYYY"),"MMM D, YYYY"));
    };
    const handleStartDateOnchange = (e) => {
      // setStartDate(moment.tz(e, "America/New_York"));

      setStartDate(new Date(e.toJSON()));


      setStartTime(moment.tz(e, "America/New_York").startOf('day'))
      setEndTime(moment.tz(e, "America/New_York").startOf('day'))
    }
    const handleEndDateOnchange = (e) => {

        setEndDate(moment.tz(e, "America/New_York"));
    }
    const handleStartTimeOnchange = (e) => {
        setStartTime(moment.tz(e, "America/New_York"));
    }
    const handleEndTimeOnchange = (e) => {
        setEndTime(moment.tz(e, "America/New_York"));
    }

  useEffect(() => {

    
    dispatch(fetchWeeklyHoursCoachAvailability({handle:props.userDetails.handle}))

    const days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    const setdays = [];
    days.forEach((d) => {
      setdays.push({
        value: d,
        label: d,
      });
    });
    // setdays.unshift({ value: "all", label: "Everyday" });
    setRepeatDays(setdays);
  }, []);

  //Modal Behaviour
  const [modal, setModal] = useState(false);

  const modalToggle = () => {

    setStartDate();
    setStartTime();
    setEndTime()
    setDescription("")
    setCutoffHours(0)

    setModal(!modal)
  
  };

  const [backdrop, setBackdrop] = useState(true);

  const createAvailability = () => {
    setBackdrop(true);
    setModal(true);
  };

  
  const saveSchedule = async () => {
      

      // console.log(moment.utc(startTime).format())
      // Swal.fire({
      //   allowOutsideClick: false,
      //   didOpen: () => {
      //     Swal.showLoading();
      //   },
      // });
        const dataDays = [];
        if (selectedDays) {
          selectedDays.map((i) => dataDays.push(i.value));
        }


        const docs = {
            startdate: convertThedate(startDate),
            // enddate: convertThedate(endDate),
            enddate: convertThedate(startDate),
            starttime: moment(convertThedate(startDate), "MMM D, YYYY").format("YYYY-MM-DD") + moment.utc(startTime).format().slice(10),
            endtime: moment(convertThedate(startDate), "MMM D, YYYY").format("YYYY-MM-DD") + moment.utc(endTime).format().slice(10),
            description: description,
            //   status: switched,
            days: dataDays,
            userHandle: props.userDetails.handle,
            cutoffHours: cutoffHours,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        };
        
        if(startTime == undefined || endTime == undefined || startDate == undefined){
          Swal.fire({
              title: "Failed!",
              text: "Please fill all the required field!",
              icon: "error"
          });

          return false;
        }
        
        if(moment(moment(startTime).tz("America/New_York").format("h:mm A"), "h:mm A").isSameOrAfter(moment(moment(endTime).tz("America/New_York").format("h:mm A"), "h:mm A"))){
        

          
          Swal.fire({
            title: "Failed!",
            text: "Start time should earlier than end time!",
            icon: "error"
          });
          
          return false
        }
        
        // console.log(docs)

        const newData = await addDoc(collection(db, "coachAvailableSchedule"), docs);
        const docRef = doc(db, "coachAvailableSchedule", newData.id);
        const docSnap = await getDoc(docRef);

       
        if (docSnap.exists()) {
            Swal.fire({
                title: "Success",
                text: "Successfully created schedule!",
                icon: "success",
                timer: 3000,
            }).finally(() => {
              // /* Read more about handling dismissals below */
              // if (result.dismiss === Swal.DismissReason.timer) {
                modalToggle()
                dispatch(fetchCoachTutorAvailability({handle: props.userDetails.handle}));
                // setModal(!modal)
              // }
            });
            
        }

      
  }

  const convertThedate = (paramDate) => {

    return moment(paramDate,"MMMM D, YYYY h:mm A").format('ll');

  }

  // const convertDefault = (date) => {
  //   return moment(date).format()
  // }

  // const convertTheTime = (time) => {
    
  //   return moment(new Date(time)).format("h:mm A") 
  // }

  const convertTimeToLocal = (time) => {
    
    return moment(moment.tz(time, "America/New_York"), "HH:mm A")
  }

  const columns = [
   
    // {
    //   name: "Date",
    //   selector: (row) => {
    //      return row.startdate + ' - '+ row.enddate ;
    //   },
    // },
    {
      name: <>Date&nbsp;<span className='text-warning'>(EST/EDT)</span> </>,
      selector: (row) => {
         return row.startdate ;
      },
    },
    // {
    //   name: "Repeat Days",
    //   selector: (row) => {
    //      return row.days.toString()
    //   },
    // },

    {
      name: <>Time&nbsp;<span className='text-warning'>(EST/EDT)</span> </>,
      selector: (row) => {
        return convertTimeToLocal(row.starttime).format('h:mm A') + ' - ' + convertTimeToLocal(row.endtime).format('h:mm A')
        // return row.starttime + ' - ' + row.endtime
      },
      wrap: true,
      width:"160px"
    },
    {
      name: "Cutoff Hrs",
      cell: (row) => {
        return typeof row.cutoffHours == "undefined" || row.cutoffHours == 0 ? "-" : row.cutoffHours + " hours"
      },
      wrap: true,
      width:"110px"
    },
   
    {
      name: "",
      cell: (row) => (
        <CoachSchedule  item={row}/>
      ),
      width:"100px"
      // center: true,
    },
  ];

   const tableHeaderstyle = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        // backgroundColor: "#ccc",
      },
    },
  };

  //   useEffect(() => {
    
  //   const result = data.filter((item) => {
  //     return (
  //       item.days.toString().match(search.toLocaleLowerCase()) ||
  //       convertThedate(item.startdate).toLowerCase().match(search.toLocaleLowerCase()) ||
  //       convertThedate(item.enddate).toLowerCase().match(search.toLocaleLowerCase()) ||
  //       convertTheTime(item.starttime).toLowerCase().match(search.toLocaleLowerCase()) ||
  //       convertTheTime(item.endttime).toLowerCase().match(search.toLocaleLowerCase()) 
  //     );
  //   });
    
  //   setFilter(result);
  // }, [search]);

  
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const [slots, setSlots] = useState([]);
  const [dayCutoffHours, setDayCutoffHours] = useState({
    Sunday: 0,
    Monday: 0,
    Tuesday: 0,
    Wednesday: 0,
    Thursday: 0,
    Friday: 0,
    Saturday: 0,
  });

  const [copySourceDay, setCopySourceDay] = useState(null);
  const [copyTargetDays, setCopyTargetDays] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // 🔹 Helper: get next occurrence of a given weekday
  const getNextDayDate = (dayName) => {
    const today = moment.tz("America/New_York");
    const targetDay = daysOfWeek.indexOf(dayName);

    let next = today.clone().day(targetDay);
    if (next.isSameOrBefore(today, "day")) {
      next = next.add(1, "week");
    }
    return next;
  };

  // 🔹 Add new slot
  const handleAddSlot = (day) => {
    // find all slots for this day
    const daySlots = slots.filter((s) => s.days[0] === day);

    let startNY, endNY;

    if (daySlots.length > 0) {
      // sort by endtime and take the latest
      const lastSlot = daySlots.reduce((latest, s) =>
        moment(s.endtime).isAfter(latest.endtime) ? s : latest
      );

      startNY = moment(lastSlot.endtime).tz("America/New_York");
      endNY = startNY.clone().add(1, "hour");
    } else {
      // if no slots yet, default to next occurrence midnight
      const nextDay = getNextDayDate(day);
      startNY = nextDay.clone().startOf("day");
      endNY = startNY.clone().add(1, "hour");
    }

    const newSlot = {
      createdAt: moment().toISOString(),
      updatedAt: moment().toISOString(),
      userHandle: props.userDetails.handle,
      description: "",
      days: [day],
      location: "New York",
      startdate: startNY.format("MMM DD, YYYY"),
      enddate: endNY.format("MMM DD, YYYY"),
      starttime: convertTimeToLocal(startNY),
      endtime:  convertTimeToLocal(endNY),
      error: "",
      cutoffHours: dayCutoffHours[day], // renamed field
    };

    dispatch(createWeeklyHoursCoachAvailability({data:newSlot}))

    // setSlots((prev) => [...prev, newSlot]);
  };


  // 🔹 Delete specific slot
  const handleRemoveSlot = (index) => {

    dispatch(deleteWeeklyHoursCoachAvailability({id : slots[index].id}))
    
    // setSlots((prev) => prev.filter((_, i) => i !== index));
  };


  const debouncedUpdateWeeklyHoursCoachAvailabilityRef = useRef(
    debounce((data, index) => {
      
      if(!moment(data[index].endtime).isSameOrBefore(moment(data[index].starttime)) && !checkOverlap(data, index)){
        dispatch(updateWeeklyHoursCoachAvailability({ data: data[index] }));
      }
      
    }, 2000)
  );


  // 🔹 Update slot times + validation
  const handleChangeSlot = (index, field, value) => {
    setSlots((prev) => {
      const updated = [...prev];
      const m = moment(value).tz("America/New_York");

      if (field === "starttime" || field === "endtime") {
        updated[index][field] = convertTimeToLocal(m);
        updated[index][field === "starttime" ? "startdate" : "enddate"] =
          m.format("MMM DD, YYYY");
      } else {
        updated[index][field] = value;
      }

      const start = moment(updated[index].starttime);
      const end = moment(updated[index].endtime);
      if (end.isSameOrBefore(start)) {
        updated[index].error = "Choose an end time later than the start time";
        
      } else if (checkOverlap(updated, index)) {
        updated[index].error = "Times overlap with another set of times";
     
      }
      else if (!start.isValid() || !end.isValid()){
        updated[index].error = "Start time and End time are required";
      }
      else {
        updated[index].error = "";
        updated[index].updatedAt = moment().toISOString();
      
        // debouncedUpdateWeeklyHoursCoachAvailability(updated[index]);
        debouncedUpdateWeeklyHoursCoachAvailabilityRef.current(updated, index);
      }

      return updated;
    });
  };

  // // 🔹 Update buffer for a whole day
  // const updateCutoffHoursForDay = (day, hours) => {
  //   setDayCutoffHours((prev) => ({ ...prev, [day]: hours }));
  //   setSlots((prev) =>
  //     prev.map((slot) =>
  //       slot.days[0] === day ? { ...slot, cutoffHours: hours } : slot
  //     )
  //   );
  // };

  const updateCutoffHoursForDay = (day, hours) => {
    setDayCutoffHours((prev) => ({ ...prev, [day]: hours }));

    setSlots((prev) => {
      const updated = prev.map((slot) =>
        slot.days[0] === day ? { ...slot, cutoffHours: hours, updatedAt: moment().toISOString() } : slot
      );

      // 🔹 Batch update all affected slots in Firestore
      const slotsToUpdate = updated.filter((slot) => slot.days[0] === day);
      if (slotsToUpdate.length > 0) {
        dispatch(updateWeeklyHoursCoachAvailability({ data: slotsToUpdate })); 
        // note: your backend supports single + multiple updates now
      }

      return updated;
    });
  };


  // 🔹 Copy slots to other days
  const handleOpenCopyModal = (day) => {
    setCopySourceDay(day);
    setCopyTargetDays([]);
    setShowModal(true);
  };

  const handleApplyCopy = () => {
    if (!copySourceDay || copyTargetDays.length === 0) return;

    const sourceSlots = slots.filter((s) => s.days[0] === copySourceDay);

    // build new slots array
    const newSlots = copyTargetDays.flatMap((day) =>
      sourceSlots.map((slot) => {
        const nextDay = getNextDayDate(day);

        const startNY = moment(slot.starttime).tz("America/New_York");
        const endNY = moment(slot.endtime).tz("America/New_York");

        const newStart = nextDay.clone().hour(startNY.hour()).minute(startNY.minute()).second(0).milliseconds(0);
        const newEnd = nextDay.clone().hour(endNY.hour()).minute(endNY.minute()).second(0).milliseconds(0);

        return {
          ...slot,
          days: [day],
          startdate: newStart.format("MMM DD, YYYY"),
          enddate: newEnd.format("MMM DD, YYYY"),
          starttime: convertTimeToLocal(newStart),
          endtime: convertTimeToLocal(newEnd),
          cutoffHours: dayCutoffHours[day],
          createdAt: moment().toISOString(),
          updatedAt: moment().toISOString(),
          description: "",
          userHandle: props.userDetails.handle,
        };
      })
    );

    // collect deletes
    const deleteIds = slots.map((s) => {

      if(copyTargetDays.includes(s.days[0])){

        

        if(typeof s.id != "undefined"){
          return  s.id
        }
      }
    }).filter(v => v !== undefined);

    // 🔹 Dispatch once instead of spamming
    
    if (deleteIds.length > 0) {
  
      dispatch(deleteWeeklyHoursCoachAvailability({ ids: deleteIds })); // accept array
    }


    if (newSlots.length > 0) {
     
      dispatch(createWeeklyHoursCoachAvailability({ data: newSlots })); // accept array
    }


    // // update local state
    // setSlots((prev) => {
    //   const withoutSource = prev.filter((s) => s.days[0] !== copySourceDay);
    //   return [...withoutSource, ...newSlots];
    // });

    setShowModal(false);
  };


  const toggleDaySelection = (day) => {
    setCopyTargetDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const checkOverlap = (slots, currentIndex) => {
    const current = slots[currentIndex];
    const currentStart = moment(current.starttime);
    const currentEnd = moment(current.endtime);

    return slots.some((slot, idx) => {
      if (idx === currentIndex) return false; // ignore self
      if (slot.days[0] !== current.days[0]) return false; // only check same day

      const start = moment(slot.starttime);
      const end = moment(slot.endtime);

      // Overlap happens if:
      // currentStart < end && currentEnd > start
      return currentStart.isBefore(end) && currentEnd.isAfter(start);
    });
  };

  useEffect(() => {
    
    if(props.createWeeklyHoursCoachAvailability.createweeklyhourscoachavailability.length || props.updateWeeklyHoursCoachAvailability.updateweeklyhourscoachavailability.length || props.deleteWeeklyHoursCoachAvailability.deleteweeklyhourscoachavailability.length){

      

      dispatch(fetchWeeklyHoursCoachAvailability({handle:props.userDetails.handle}))

      toast.success("Your settings have been saved!", { position: "top-center", toastId: "unique-error" });

      dispatch(updateWeeklyHoursCoachAvailabilityReset())
      dispatch(createWeeklyHoursCoachAvailabilityReset())
      dispatch(deleteWeeklyHoursCoachAvailabilityReset())

    }

  }, [props.createWeeklyHoursCoachAvailability, props.updateWeeklyHoursCoachAvailability, props.deleteWeeklyHoursCoachAvailability])

  useEffect(() => {
    
    if(props.fetchWeeklyHoursCoachAvailability.fetchweeklyhourscoachavailability.length){
      const dataSlots = props.fetchWeeklyHoursCoachAvailability.fetchweeklyhourscoachavailability[0]
      setSlots(dataSlots)

      if (dataSlots.length > 0) {
        const cutoffMap = {};
        daysOfWeek.forEach((day) => {
          const slot = dataSlots.find((s) => s.days[0] === day);
          cutoffMap[day] = slot?.cutoffHours ?? 0;
        });
        setDayCutoffHours(cutoffMap);
      }

    }

  }, [props.fetchWeeklyHoursCoachAvailability])
  

  const handleCutoffHoursOnChange = (e) => {
    setCutoffHours(e.target.value)
  }


  return (
    <>
      <Header></Header>

      <Container className="mt--7 pb-5" fluid>
        {/* <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-1">
                <div className="float-left d-none d-md-block d-lg-block">
                  <h className="h3 mb-0">Manage Coach Tutor Availability</h>
                </div>
                <div>
                  <Button
                    color="success"
                    className="float-right"
                    onClick={createAvailability}
                  >
                    Create Schedule Availability
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <h6 className="heading-small text-muted mb-4">
                  Set Availability
                </h6>
                <div className="pl-lg-4">
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-first-name"
                        >
                          Date <span className="text-danger">*</span>
                        </label>
                        <ReactDatetime
                        //   onChange={(e) => handleDateOnChange(e)}
                          isValidDate={valid}
                          timeFormat={false}
                          className="w-100"
                          inputProps={{ placeholder: "Select Date" }}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-first-name"
                        >
                          From <span className="text-danger">*</span>
                        </label>
                        <ReactDatetime
                          value={timeFrom}
                          onChange={(e) => handleTimeFromOnChange(e)}
                          timeConstraints={{
                            minutes: { min: 0, max: 0, step: 0 },
                          }}
                          dateFormat={false}
                          className="w-100"
                          inputProps={{ placeholder: "Select time" }}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-first-name"
                        >
                          To <span className="text-danger">*</span>
                        </label>
                        <ReactDatetime
                          value={timeTo}
                          onChange={(e) => handleTimeToOnChange(e)}
                          timeConstraints={{
                            minutes: { min: 0, max: 0, step: 0 },
                          }}
                          dateFormat={false}
                          className="w-100"
                          inputProps={{ placeholder: "Select time" }}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="12">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor="input-first-name"
                        >
                          Description for student
                        </label>
                        <Input
                          id="inputNotesForStudents"
                          name="inputExperienceDescription"
                          placeholder="Write a description..."
                          rows="5"
                          type="textarea"
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>

                <Col lg="12 mt-3"></Col>
              </CardBody>
              <CardFooter>
                <Button
                  color="primary"
                //   onClick={(e) => handleCoachTutorAvailabilityOnClick(e)}
                  type="submit"
                >
                  Save
                </Button>
              </CardFooter>
            </Card>
          </div>
        </Row> */}
        <Row>
          <Col>
            <Card className="shadow">
            <CardHeader className="border-1">
                <div className="float-left ">
                  <h3 className="h3 mb-0">Manage Coach Tutor Availability</h3>
                </div>
                 <div>
                  
                </div>
               
              </CardHeader>
              <CardBody> 
               
                <Row>
                  <Col lg="12"><h2 className="text-info mb-3"><i class="fas fa-clock"></i> Timezone : America/New_York</h2></Col>
                  <Col lg="6">
               
                    <Row>
                      <Col lg="12" className="mb-2">
                        
                        

                        {/* <div className="d-flex align-items-center">
                          <span
                            className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                            style={{
                              width: 40,
                              height: 40,
                              fontSize: Math.max(12, Math.floor(40 * 0.45))
                            }}
                          >
                            A
                          </span> */}
                          {/* <span className="text-muted ml-3">Unavailable</span> */}

                          {/* <ReactDatetime
                  
                            value={startTime}
                            onChange={(e) => handleStartTimeOnchange(e)}
                            timeConstraints={{
                              minutes: { min: 30, max: 30, step: 31 },
                            }}
                            dateFormat={false}
                            
                            className="ml-3 my-datetime w-25"
                            inputProps={{ placeholder: "Select time" }}
                          />
                          &nbsp;-&nbsp; 
                          <ReactDatetime
                          
                            value={startTime}
                            onChange={(e) => handleStartTimeOnchange(e)}
                            timeConstraints={{
                              minutes: { min: 30, max: 30, step: 31 },
                            }}
                            dateFormat={false}
                            className="my-datetime w-25"
                            inputProps={{ placeholder: "Select time" }}
                          />
                          <span className=" ml-3">
                            <a href="#" className="text-danger"><i class="fas fa-trash"></i></a>
                            <a href="#" className="text-warning ml-3"><i class="fas fa-plus"></i></a>
                            <a href="#" className="text-info ml-3"><i class="fas fa-copy"></i></a>
                          </span>
                        </div> */}
                        
                        <h2><svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512"><path d="M512 256c0 88.224-71.775 160-160 160H170.067l34.512 32.419c9.875 9.276 10.119 24.883.539 34.464l-10.775 10.775c-9.373 9.372-24.568 9.372-33.941 0l-92.686-92.686c-9.373-9.373-9.373-24.568 0-33.941l92.686-92.686c9.373-9.373 24.568-9.373 33.941 0l10.775 10.775c9.581 9.581 9.337 25.187-.539 34.464L170.067 352H352c52.935 0 96-43.065 96-96 0-13.958-2.996-27.228-8.376-39.204-4.061-9.039-2.284-19.626 4.723-26.633l12.183-12.183c11.499-11.499 30.965-8.526 38.312 5.982C505.814 205.624 512 230.103 512 256zM72.376 295.204C66.996 283.228 64 269.958 64 256c0-52.935 43.065-96 96-96h181.933l-34.512 32.419c-9.875 9.276-10.119 24.883-.539 34.464l10.775 10.775c9.373 9.372 24.568 9.372 33.941 0l92.686-92.686c9.373-9.373 9.373-24.568 0-33.941l-92.686-92.686c-9.373-9.373-24.568-9.373-33.941 0L306.882 29.12c-9.581 9.581-9.337 25.187.539 34.464L341.933 96H160C71.775 96 0 167.776 0 256c0 25.897 6.186 50.376 17.157 72.039 7.347 14.508 26.813 17.481 38.312 5.982l12.183-12.183c7.008-7.008 8.786-17.595 4.724-26.634z"/></svg>&nbsp;Weekly hours</h2>

                        <p>Set when you are typically available for meetings</p>
                        <div>
                          {daysOfWeek.map((day) => {
                            const daySlots = slots
                              .map((slot, index) => ({ ...slot, realIndex: index }))
                              .filter((s) => s.days[0] === day);

                            return (
                              <div key={day} className="mb-4">
                                <h6>
                                  {day}
                                  <select
                                    value={dayCutoffHours[day]}
                                    onChange={(e) =>
                                      updateCutoffHoursForDay(day, parseInt(e.target.value, 10))
                                    }
                                    className="form-control w-75"
                                    style={{ width: "150px" }}
                                  >
                                    <option value={0}>Cutoff Hours</option>
                                    <option value={4}>4 hours</option>
                                    <option value={8}>8 hours</option>
                                    <option value={16}>16 hours</option>
                                  </select>
                                </h6>

                                {daySlots.length === 0 ? (
                                  <a
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleAddSlot(day);
                                    }}
                                    className="text-warning"
                                  >
                                    Unavailable<i className="ml-3 fas fa-plus"></i>
                                  </a>
                                ) : (
                                  daySlots.map((slot, idx) => (
                                    <div key={slot.realIndex} className="d-flex flex-column mb-2">
                                      <div className="d-flex align-items-center">
                                        <ReactDatetime
                                          value={
                                            slot.starttime ? convertTimeToLocal(slot.starttime) : ""
                                          }
                                          onChange={(val) =>
                                            handleChangeSlot(slot.realIndex, "starttime", val)
                                          }
                                          timeConstraints={{
                                            minutes: { min: 30, max: 30, step: 31 },
                                          }}
                                          dateFormat={false}
                                          className="my-datetime w-25"
                                          inputProps={{ placeholder: "Start time" }}
                                        />
                                        &nbsp;-&nbsp;
                                        <ReactDatetime
                                          value={
                                            slot.endtime ? convertTimeToLocal(slot.endtime) : ""
                                          }
                                          onChange={(val) =>
                                            handleChangeSlot(slot.realIndex, "endtime", val)
                                          }

                                          timeConstraints={{
                                            minutes: { min: 30, max: 30, step: 31 },
                                          }}

                                          dateFormat={false}
                                          className="my-datetime w-25"
                                          inputProps={{ placeholder: "End time" }}
                                        />
                                        <span className="ml-3">
                                          {/* Always delete */}
                                          <a
                                            href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              handleRemoveSlot(slot.realIndex);
                                            }}
                                            className="text-danger"
                                          >
                                            <i className="fas fa-trash"></i>
                                          </a>

                                          {/* First slot gets Add + Copy */}
                                          {idx === 0 && (
                                            <>
                                              <a
                                                href="#"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  handleAddSlot(day);
                                                }}
                                                className="text-warning ml-3"
                                              >
                                                <i className="fas fa-plus"></i>
                                              </a>
                                              <a
                                                href="#"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  handleOpenCopyModal(day);
                                                }}
                                                className="text-info ml-3"
                                              >
                                                <i className="fas fa-copy"></i>
                                              </a>
                                            </>
                                          )}
                                        </span>
                                      </div>
                                      {slot.error && (
                                        <small className="text-danger mt-1">{slot.error}</small>
                                      )}
                                    </div>
                                  ))
                                )}

                                

                              </div>
                            );
                          })}

                          {/* Copy Modal */}
                          {showModal && (
                            <div
                              className="modal d-block"
                              tabIndex="-1"
                              style={{ background: "rgba(0,0,0,0.5)" }}
                            >
                              <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title">
                                      Copy schedule from {copySourceDay}
                                    </h5>
                                    <button
                                      type="button"
                                      className="btn-close"
                                      onClick={() => setShowModal(false)}
                                    ></button>
                                  </div>
                                  <div className="modal-body">
                                    {daysOfWeek
                                      .filter((d) => d !== copySourceDay)
                                      .map((day) => (
                                        <div key={day}>
                                          <label>
                                            <input
                                              type="checkbox"
                                              checked={copyTargetDays.includes(day)}
                                              onChange={() => toggleDaySelection(day)}
                                            />{" "}
                                            {day}
                                          </label>
                                        </div>
                                      ))}
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() => setShowModal(false)}
                                    >
                                      Cancel
                                    </button>
                                    <button className="btn btn-primary" onClick={handleApplyCopy}>
                                      Apply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Debug JSON */}
                          {/* <pre>{JSON.stringify(slots, null, 2)}</pre> */}
                        </div>

                      </Col>
                      
                  
                  
                    </Row>
                  </Col>
                  <Col lg="6">
                  
                  

                  <Row>
                    <Col>
                      <div>
                        <h2><i class="fas fa-clock"></i>&nbsp;Date-specific hours</h2>
                        <p>Adjust hours for specific days</p>
                      </div>
                    </Col>
                    <Col className="d-flex justify-content-end align-items-center">
                      <Button
                        color="warning"
                        className="float-right"
                        onClick={createAvailability}
                      >
                        <i class="fas fa-plus"></i> Hours
                      </Button>
                    
                    </Col>
                  </Row>
                   {data.length ? (
                      
                      <DataTable
                        customStyles={tableHeaderstyle}
                        columns={columns}
                        data={filter}
                        pagination
                        wrap
                        // selectableRows
                        // fixedHeader
                        selectableRowsHighlight
                        highlightOnHover
                        // subHeader
                        // subHeaderComponent={
                        //   <input
                        //     type="text"
                        //     className="w-50 form-control"
                        //     placeholder="Search a keyword content..."
                        //     value={search}
                        //     onChange={(e) => setSearch(e.target.value)}
                        //   />
                        // }
                        // subHeaderAlign="right"
                      />
                    ) : (
                      <Alert color="primary">No data available .</Alert>
                    )}
                  </Col>
                </Row>
              </CardBody>
              <CardFooter></CardFooter>
            </Card>
          </Col>
        </Row>

       
       
        <Modal
          isOpen={modal}
          toggle={modalToggle}
          backdrop={backdrop}
          size="lg"
          centered
        >
          <ModalHeader toggle={modalToggle}>
            Create Schedule Availability
          </ModalHeader>
          <ModalBody className="pt-1">
            
            <Row>
              <Col lg="6">
                  <FormGroup>
                  <label
                      className="form-control-label"
                      htmlFor="input-first-name"
                  >
                      Date <span className="text-danger"> *</span>
                  </label>
                  <ReactDatetime
                      onChange={(e) => handleStartDateOnchange(e)}
                      isValidDate={valid}
                      timeFormat={false}
                      className="w-100"
                      inputProps={{ placeholder: "Select Date" }}
                  />
                  </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <label
                      className="form-control-label"
                      htmlFor="input-first-name"
                  >
                      Cutoff Hours  <span className="text-danger">*</span>
                  </label>
                  <select
                    
                    onChange={(e) => handleCutoffHoursOnChange(e)}
                    className="form-control w-100"
                    style={{ width: "150px" }}
                  >
                    <option value={0}>Cutoff hours</option>
                    <option value={4}>4 hours</option>
                    <option value={8}>8 hours</option>
                    <option value={16}>16 hours</option>
                  </select>
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-first-name"
                  >
                    Start Time <span className="text-danger">*</span>
                  </label>
                  <ReactDatetime
                  
                    value={startTime}
                    onChange={(e) => handleStartTimeOnchange(e)}
                    timeConstraints={{
                       minutes: { min: 30, max: 30, step: 31 },
                    }}
                    dateFormat={false}
                    className="w-100"
                    inputProps={{ placeholder: "Select time" }}
                  />
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="input-first-name"
                  >
                    End Time <span className="text-danger">*</span>
                  </label>
                  <ReactDatetime
                    
                    value={endTime}
                    onChange={(e) => handleEndTimeOnchange(e)}
                    timeConstraints={{
                       minutes: { min: 30, max: 30, step: 31 },
                    }}
                    dateFormat={false}
                    className="w-100"
                    inputProps={{ placeholder: "Select time" }}
                  />
                </FormGroup>
             
              </Col>
              <Col lg="12">
                    {/* <Label>Select days to repeat the time schedule</Label>
                    <FormGroup>
                        <Select
                        menuPortalTarget={document.body}
                        menuPosition={"fixed"}
                        styles={customStyles}
                        isMulti
                        options={repeatDays}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={selectedDays}
                        onChange={setSelectedDays}
                        />
                    </FormGroup> */}
                </Col>
                <Col lg="12">
      
                    <FormGroup>
                    <label
                        className="form-control-label"
                        htmlFor="input-first-name"
                    >
                        Description
                    </label>
                    <Input
                        placeholder="Write a description..."
                        rows="5"
                        type="textarea"
                        onChange={(e) => setDescription(e.target.value)}
                    />
                    </FormGroup>
                </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={modalToggle}>
              Cancel
            </Button>
            <Button color="primary" onClick={saveSchedule}>Save</Button>
          </ModalFooter>
        </Modal>

     
      </Container>

      <style>
        {`
          .my-datetime .rdtPicker {
            min-width: 250px;
            
            z-index: 9999;
          }
          .rdtCounter{
            min-width: 41px;
          }
        `}
      </style>
      <ToastContainer autoClose={1000} limit={1}/>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.loginAuth.userDetails,
    createCoachTutorAvailability: state.createCoachTutorAvailability,
    fetchCoachTutorAvailability: state.fetchCoachTutorAvailability,
    fetchHistoryCoachTutorAvailability:state.fetchHistoryCoachTutorAvailability,
    deleteCoachTutorAvailability: state.deleteCoachTutorAvailability,


    createWeeklyHoursCoachAvailability: state.createWeeklyHoursCoachAvailability,
    updateWeeklyHoursCoachAvailability: state.updateWeeklyHoursCoachAvailability,
    deleteWeeklyHoursCoachAvailability: state.deleteWeeklyHoursCoachAvailability,
    fetchWeeklyHoursCoachAvailability: state.fetchWeeklyHoursCoachAvailability
  };
};

export default connect(mapStateToProps)(ManageCoachTutorAvailability);
